import { useEffect, useState } from 'react';

import AD_QUANTITY from './components/Dropdown/constants';

function useAutosPlansSubscription() {
  const [adQuantity, selectedAdQuantity] = useState(AD_QUANTITY[0].value);

  function onChangeAdQuantity(value) {
    selectedAdQuantity(value);
  }

  useEffect(() => {
    onChangeAdQuantity(AD_QUANTITY[0].value);
  }, []);


  return {
    adQuantity,
    onChangeAdQuantity,
  };
}

export default useAutosPlansSubscription;
